import { Button } from "@/components/ui/baseUi/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/baseUi/dialog"
import { WarningTriangleIcon } from "@images/svgIcons/warningIcon"
import { word } from "@modules/core/utils/i18n"
import { ProgramType } from "@modules/programs/types/programTypes"
import { useImperativeHandle, useState } from "react"
import { Text } from "@/components/ui/baseUi/text"

type ProgramBundleNoUnfollowModalProps = {
  programType: ProgramType
  ref: React.Ref<ProgramBundleNoUnfollowModalRef>
}

export type ProgramBundleNoUnfollowModalRef = {
  open: () => void
}

export function ProgramBundleNoUnfollowModal({ programType, ref }: ProgramBundleNoUnfollowModalProps) {
  const [dialogIsVisible, setDialogIsVisible] = useState(false)
  const closeDialog = () => {
    setDialogIsVisible(false)
  }

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogIsVisible(true)
    },
  }))

  return (
    <Dialog open={dialogIsVisible} onOpenChange={setDialogIsVisible}>
      <DialogContent className="h-83 w-128">
        <DialogHeader className="flex flex-col gap-4">
          <DialogTitle>{word("programBundle.follow.remove.impossible.title")}</DialogTitle>
          <DialogDescription className="mb-5 flex flex-row">
            <WarningTriangleIcon color="currentColor" width={50} height={50} className="text-textDefault-caption" />
            <Text fontStyle="TL">{word("programBundle.follow.remove.impossible.title")}</Text>
          </DialogDescription>
        </DialogHeader>

        <Text fontStyle="BM" className="text-center">
          {programType === ProgramType.ONOFF
            ? word("programBundle.follow.remove.impossible.explanation.onOff")
            : word("programBundle.follow.remove.impossible.explanation.infinite")}
        </Text>

        <DialogFooter>
          <Button variant="primary" className="w-full" onClick={closeDialog}>
            {word("global.understood")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
